export default function primeiroNome(nome) {
  try {
    nome = nome.split(" ");
    return nome[0];
  } catch (err) {
    return "";
  }
}
